import React from 'react';
import { useNavigate } from 'react-router';
import { Avatar } from '@heroui/react';
import { Typography } from '../../../../components';
import { RefShareOrder, OwnerLevel } from '../../../../api/services';

interface MarketerCellProps {
  order: RefShareOrder;
}

const levelConfig: Record<OwnerLevel, { bgColor: string; textColor: string; label: string }> = {
  new: { bgColor: 'rgba(23, 201, 100, 0.15)', textColor: '#17C964', label: 'New' },
  base: { bgColor: '#EEEEEF', textColor: '#71717A', label: 'Base' },
  pro: { bgColor: '#11181c', textColor: '#ffffff', label: 'Pro' },
  expert: { bgColor: 'rgba(120, 40, 200, 0.15)', textColor: '#7828c8', label: 'Expert' },
  bronze: { bgColor: '#FDF4E7', textColor: '#CD7F32', label: 'Bronze' },
  silver: { bgColor: '#F0F0F0', textColor: '#808080', label: 'Silver' },
  gold: { bgColor: '#FFF9E6', textColor: '#FFD700', label: 'Gold' },
  platinum: { bgColor: '#E8F4F8', textColor: '#A0B2C6', label: 'Platinum' },
  diamond: { bgColor: '#E6F3FF', textColor: '#00BFFF', label: 'Diamond' },
};

const MarketerCell: React.FC<MarketerCellProps> = ({ order }) => {
  const navigate = useNavigate();

  // Marketer (partner) comes from owner field
  const marketer = order.owner;
  if (!marketer || typeof marketer === 'string') {
    return <span className="text-[#71717A]">—</span>;
  }

  const marketerId = marketer._id || marketer.id || '';
  const href = `/users/partners/${marketerId}`;
  const level = marketer.lvl;
  const levelStyle = level ? levelConfig[level] : null;

  return (
    <div className="flex items-center gap-[12px] py-2">
      <Avatar
        src={marketer.avatar}
        name={marketer.name?.charAt(0)}
        size="sm"
        className="w-[40px] h-[40px] rounded-[12px]"
      />
      <div className="flex flex-col gap-[4px]">
        <div className="flex items-center gap-[8px]">
          <span
            onClick={() => navigate(href)}
            className="text-[#006FEE] text-[14px] font-semibold hover:underline cursor-pointer"
          >
            {marketer.name}
          </span>
          {levelStyle && (
            <span
              className="px-[8px] py-[2px] rounded-full text-[11px] font-medium"
              style={{
                backgroundColor: levelStyle.bgColor,
                color: levelStyle.textColor,
              }}
            >
              {levelStyle.label}
            </span>
          )}
        </div>
        <Typography variant="body3" className="text-[#71717A]">
          Маркетолог
        </Typography>
      </div>
    </div>
  );
};

export default MarketerCell;
